export const CHANGE_BOARD = 'events/CHANGE_BOARD';

/**
 * @param boardId
 * @param isPublic
 * @return {{type: object, payload: {boardId: *, isPublic: *}}}
 */
export const changeBoard = (boardId, isPublic) => ({
  type: CHANGE_BOARD,
  payload: { boardId, isPublic },
});
